import "./ImageGallery.scss";
import { PrimaryBtn } from "../../../components/index";
import { useState } from "react";
import ImagePreview from "../imagePreview/ImagePreview";
import { baseUrl } from "../../../utils/apiData";
import useExecuteContext from "../../../utils/hooks/executeContext";

const ImageGallery = ({ dataList }) => {
  const [modalShow, setModalShow] = useState(false);
  const item = 6;
  const [num, setNum] = useState(0);
  const { setPreviewNum } = useExecuteContext();
  return (
    <section className="image_gallery">
      <div className="content_wrap p_b">
        <div className="tri_grid">
          {dataList?.slice(0, item * num + item)?.map((data, k) => {
            return (
              <div
                className="img_card"
                key={data?._id}
                onClick={() => {
                  setPreviewNum(k);
                  setModalShow(true);
                }}
              >
                <img src={`${baseUrl}/${data.image}`} alt="Preview" />
              </div>
            );
          })}
        </div>
        {item * num + item < dataList?.length && (
          <div className="btn_line">
            <PrimaryBtn
              theme="gold"
              title="load More"
              clickHandler={() => setNum((prev) => prev + 1)}
            />
          </div>
        )}
      </div>
      <ImagePreview
        show={modalShow}
        onHide={() => setModalShow(false)}
        datalist={dataList}
      />
    </section>
  );
};

export default ImageGallery;
